import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';

import { useAuthenticated } from './services/hooks/';
import { AppEmployeeRoutes, AppClientRoutes, LandingRoutes, AppClientZSRoutes } from './routes';
import ThemeProvider from './theme';
// components
import RtlLayout from './components/RtlLayout';
import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import ThemeColorPresets from './components/ThemeColorPresets';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import AppGuestRoutes from './routes/AppGuestRoutes';
import ConfirmCookie from './components/ConfirmCookie';
import { Toaster } from 'react-hot-toast';
import AppStaffRoutes from './routes/AppStaffRoutes';
import AppManagerRoutes from './routes/AppManagerRoutes';
import useVersionCheck from './services/hooks/use-version-check';
import VersionUpdateDialog from './components/VersionUpdateDialog';
import { setToken } from './services/redux-actions';

export const App = () => {
  const dispatch = useDispatch();
  const { token, group } = useSelector(state => state.app);
  const { isAuthenticated } = useAuthenticated();
  const isNewVersion = useVersionCheck();

  // JEŚLI ZMIENIŁA SIĘ WERSJA FRONTENDU TO ODŚWIEŻAMY STRONĘ PRACOWNIKOM
  // ŻEBY WIDZIELI OD RAZU NOWE ZMIANY
  // WERSJA ZMIENIA SIĘ PRZY KAŻDYM BUILDZIE FRONTENDU
  if (isNewVersion && group === 'employees') {
    // window.localStorage.clear();
    window.location.reload();
  }

  library.add(fas);

  React.useEffect(() => {
    if (token) {
      return;
    }

    const loadToken = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}auth-me/`, {
          credentials: 'include'
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();

        if (data.token) {
          dispatch(setToken(data.token));
        }
      } catch (e) {
        // użytkownik nie jest zalogowany lub błąd sieci
      }
    };

    loadToken();
  }, [token, dispatch]);
  document.documentElement.lang = 'pl'; // will set the lang property to 'fr'

  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <RtlLayout>
          <NotistackProvider>
            <MotionLazyContainer>
              <ProgressBarStyle />
              <ChartStyle />
              <ScrollToTop />
              {/* <VersionUpdateDialog open={isNewVersion} /> */}
              <Routes>
                {isAuthenticated() ? (
                  group === 'employees' ? (
                    <Route path="*" element={<AppEmployeeRoutes />} />
                  ) : group === 'guests' ? (
                    <Route path="*" element={<AppGuestRoutes />} />) : group === 'staff' ? (
                    <Route path="*" element={<AppStaffRoutes />} />
                  ) : group === 'managers' ? (
                    <Route path="*" element={<AppManagerRoutes />} />
                  ) : group === 'clients_zs' ? (
                    <Route path="*" element={<AppClientZSRoutes />} />
                  ) : (
                    <Route path="*" element={<AppClientRoutes />} />
                  )
                ) : (
                  <Route path="*" element={<LandingRoutes />} />
                )}
              </Routes>
              <ConfirmCookie />
              <Toaster
                position="bottom-right"
                reverseOrder={false}
                toastOptions={{ duration: 4000 }}
              />
            </MotionLazyContainer>
          </NotistackProvider>
        </RtlLayout>
      </ThemeColorPresets>
    </ThemeProvider>

  );
};
